/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.video.abortUpload'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  jobId: /*#__PURE__*/ l.string({ minLength: 1, maxLength: 256 }),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  state: /*#__PURE__*/ l.string<{
    maxLength: 32
    knownValues: ['aborted', 'completed', 'failed', 'expired']
  }>({ maxLength: 32 }),
  completedJobId: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ minLength: 1, maxLength: 256 }),
  ),
  failureReason: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ maxLength: 1024 }),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Abort an upload only while it is created, releasing its quota reservation immediately. Terminal sessions are unchanged and return their terminal outcome. A finishing session returns UploadNotReady. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'UploadNotFound',
  'UploadNotReady',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
